export default __webpack_public_path__ + "527940b104eb2ea366c8630f3f038603.ttf";